var map = {
	"./ad.svg": "eac9",
	"./ae.svg": "ad5b",
	"./af.svg": "b836",
	"./ag.svg": "c9e9",
	"./al.svg": "056f",
	"./alarm.svg": "ca1c",
	"./alert.svg": "976f",
	"./allergens/celery.svg": "bdea",
	"./allergens/crustaceans.svg": "e36d",
	"./allergens/eggs.svg": "d32b",
	"./allergens/fish.svg": "25fe",
	"./allergens/gluten.svg": "888a",
	"./allergens/lupin.svg": "5c59",
	"./allergens/milk.svg": "03c6",
	"./allergens/molluscs.svg": "0706",
	"./allergens/mustard.svg": "d17f",
	"./allergens/peanuts.svg": "4873",
	"./allergens/sesame.svg": "eeb4",
	"./allergens/soy.svg": "7bd3",
	"./allergens/sulfites.svg": "16e6",
	"./allergens/tree-nuts.svg": "aa5a",
	"./am.svg": "6525",
	"./ao.svg": "3d53",
	"./apple-pay.svg": "78df",
	"./apply-all.svg": "12d6",
	"./ar.svg": "9c71",
	"./arrow-down-2.svg": "ea8a",
	"./arrow-down.svg": "785a",
	"./arrow-left.svg": "4dbf",
	"./arrow-right.svg": "96f9",
	"./arrow-up.svg": "5ea2",
	"./at.svg": "985d",
	"./au.svg": "da1f",
	"./aw.svg": "f163",
	"./az.svg": "ae1a",
	"./ba.svg": "1e93",
	"./back-arrow.svg": "eef5",
	"./bb.svg": "2fbe",
	"./bd.svg": "8a27",
	"./be.svg": "5b8e",
	"./bell-slash.svg": "3af2",
	"./bell.svg": "b8e0",
	"./bf.svg": "5f00",
	"./bg.svg": "0a60",
	"./bh.svg": "e4e6",
	"./bi.svg": "b5e8",
	"./bike.svg": "a8e7",
	"./bizum.svg": "f747",
	"./bj.svg": "dfef",
	"./bn.svg": "7eca",
	"./bo.svg": "8da0",
	"./br.svg": "fa3f",
	"./brands.svg": "b9b13",
	"./bs.svg": "d026",
	"./bt.svg": "9b9c",
	"./burger.svg": "d4f6",
	"./bv.svg": "00a6",
	"./bw.svg": "6500",
	"./by.svg": "5745",
	"./bz.svg": "9747",
	"./ca.svg": "6f71",
	"./calculator.svg": "6b5b",
	"./calendar-red.svg": "d7ca",
	"./calendar.svg": "7066",
	"./card.svg": "60be",
	"./cart.svg": "47f7",
	"./cash.svg": "c201",
	"./cat.svg": "2a65",
	"./catalog.svg": "a04a",
	"./cf.svg": "e7b0",
	"./cg.svg": "a9c0",
	"./ch.svg": "dfca",
	"./chain.svg": "9585",
	"./chat.svg": "0b25",
	"./check-circle.svg": "cfcb",
	"./check.svg": "e285",
	"./cl.svg": "e52d",
	"./clean.svg": "7736",
	"./clock-counter-clockwise.svg": "4053",
	"./clock-wise.svg": "c3c3",
	"./clock.svg": "c929",
	"./close-store.svg": "a71f",
	"./close.svg": "ef34",
	"./cm.svg": "ef43",
	"./cn.svg": "a56c",
	"./co.svg": "fa85",
	"./contract.svg": "366a",
	"./copies.svg": "0b54",
	"./cr.svg": "b213",
	"./cross-eye.svg": "5777",
	"./cu.svg": "a4fe",
	"./currencies/dollar.svg": "ec84",
	"./currencies/euro.svg": "ecf2",
	"./currencies/pound.svg": "4c3e",
	"./cy.svg": "c92b",
	"./cz.svg": "b578",
	"./danger.svg": "b328",
	"./de.svg": "5556",
	"./default-notification.svg": "7ce0",
	"./delete-arrow.svg": "2a2d",
	"./delivery.svg": "a663",
	"./device.svg": "1ade",
	"./diners.svg": "f66a",
	"./discount.svg": "828f",
	"./dizzy-robot-dark.svg": "4096",
	"./dizzy-robot.svg": "ea4b",
	"./dj.svg": "34ce",
	"./dk.svg": "3280",
	"./dm.svg": "91bc",
	"./do.svg": "3567",
	"./done.svg": "e36a",
	"./dots.svg": "6c6e",
	"./download.svg": "2f8f",
	"./drag.svg": "2693",
	"./dropdown-menu.svg": "b139",
	"./duplicate.svg": "518a",
	"./dz.svg": "5faf",
	"./ec.svg": "01f8",
	"./ee.svg": "a9da",
	"./eg.svg": "2a54",
	"./empanadish.svg": "0121",
	"./empty-case-dark.svg": "a3e3",
	"./empty-case.svg": "6d5c8",
	"./empty.svg": "da97",
	"./en.svg": "bac7",
	"./end-shift.svg": "6d18",
	"./er.svg": "97e2",
	"./error.svg": "b996",
	"./es.svg": "836bc",
	"./et.svg": "6880",
	"./euro.svg": "2035",
	"./expand.svg": "aa46",
	"./export.svg": "62c44",
	"./external.svg": "97e8",
	"./eye-closed.svg": "8bc2",
	"./eye-disabled.svg": "15ca",
	"./eye.svg": "0a2f",
	"./fi.svg": "cdb2",
	"./file.svg": "1319",
	"./filters.svg": "ee74",
	"./fj.svg": "245f",
	"./flag.svg": "a06d",
	"./floorplan.svg": "7437",
	"./forward.svg": "b02f",
	"./fr.svg": "2f75",
	"./ga.svg": "5349",
	"./gb.svg": "69f5",
	"./gd.svg": "7877",
	"./ge.svg": "d663",
	"./gh.svg": "09f2",
	"./gm.svg": "ab73",
	"./gn.svg": "6fb7",
	"./google-pay.svg": "f119",
	"./gq.svg": "938a",
	"./gr.svg": "b997",
	"./gt.svg": "559a",
	"./gw.svg": "d3f3",
	"./gy.svg": "a05c",
	"./handle.svg": "4ef8",
	"./headset.svg": "5685",
	"./help.svg": "6341",
	"./history.svg": "bdf3",
	"./hk.svg": "2ea9",
	"./hn.svg": "6232",
	"./home.svg": "a6c9",
	"./hr.svg": "98e1",
	"./ht.svg": "fdf2",
	"./hu.svg": "7352",
	"./id.svg": "c4ee",
	"./idle-clock.svg": "e037",
	"./ie.svg": "f58f",
	"./il.svg": "768d",
	"./import.svg": "47b8",
	"./important-round.svg": "84aa6",
	"./in-out.svg": "9179",
	"./in.svg": "514c",
	"./info.svg": "936a",
	"./integration.svg": "b5e4",
	"./iq.svg": "49b2",
	"./is.svg": "0096",
	"./it.svg": "4480",
	"./izettle.svg": "f822",
	"./jm.svg": "6f66",
	"./jo.svg": "71ab",
	"./jp.svg": "f5e0",
	"./ke.svg": "5650",
	"./kg.svg": "bc2a",
	"./kh.svg": "8772",
	"./ki.svg": "ff9f",
	"./kitchen.svg": "d287",
	"./km.svg": "5d28",
	"./kp.svg": "a27b",
	"./kr.svg": "25e4",
	"./kw.svg": "e3ee",
	"./kz.svg": "6c98",
	"./lb.svg": "4d39",
	"./lc.svg": "37da",
	"./li.svg": "87c2",
	"./line-menu.svg": "0ff7",
	"./link-break.svg": "7a1c",
	"./list.svg": "d965",
	"./lk.svg": "d0c4",
	"./loading-error.svg": "95e8",
	"./loading-spinner.svg": "ab3b",
	"./loading.svg": "a3f0",
	"./location.svg": "6365",
	"./lock.svg": "9ea5",
	"./login-logo.svg": "e807",
	"./logo.svg": "28cb",
	"./logout.svg": "e877",
	"./lr.svg": "e755",
	"./ls.svg": "0ff74",
	"./lt.svg": "d5ef",
	"./lu.svg": "a94a",
	"./lv.svg": "80de",
	"./ly.svg": "7779",
	"./ma.svg": "7a71",
	"./mail.svg": "d36e",
	"./man.svg": "fd6d",
	"./map.svg": "30b3",
	"./mc.svg": "0c95",
	"./md.svg": "8ace",
	"./me.svg": "4244",
	"./menu-hamburguer.svg": "39e3",
	"./merge.svg": "0300",
	"./mg.svg": "2499",
	"./mh.svg": "5f75",
	"./minus.svg": "8b5b",
	"./mk.svg": "48f3",
	"./ml.svg": "73cb",
	"./mm.svg": "e1090",
	"./mn.svg": "d606",
	"./mr.svg": "7895",
	"./mt.svg": "de60",
	"./mu.svg": "4a01",
	"./mute.svg": "a991",
	"./mv.svg": "2601",
	"./mw.svg": "9a87",
	"./mx.svg": "3d34",
	"./my.svg": "2c80",
	"./mz.svg": "a01f",
	"./na.svg": "411d",
	"./ne.svg": "a3c0",
	"./new.svg": "c3a2",
	"./ng.svg": "243e",
	"./ni.svg": "c467",
	"./nl.svg": "9320",
	"./no.svg": "ba66",
	"./nobookings.svg": "0bab",
	"./np.svg": "4c2c",
	"./nr.svg": "89ea",
	"./nz.svg": "6c4a",
	"./om.svg": "8aa0",
	"./order.svg": "fed7",
	"./organization.svg": "0bf0",
	"./pa.svg": "83f5",
	"./paint.svg": "1e16",
	"./payment-ticket.svg": "b27f",
	"./pe.svg": "47b2",
	"./pen.svg": "1193",
	"./pending-payment.svg": "ac8b",
	"./people.svg": "aac1",
	"./percentage.svg": "f589",
	"./pg.svg": "976fe",
	"./ph.svg": "7fa0",
	"./phone.svg": "0151",
	"./pk.svg": "a600",
	"./pl.svg": "a13c",
	"./plus.svg": "e3c7",
	"./porcentaje.svg": "6e19",
	"./power.svg": "7119",
	"./printer.svg": "28e9",
	"./product-specs/glutenfree.svg": "1020",
	"./product-specs/hot.svg": "66a7",
	"./product-specs/medium.svg": "9bf6",
	"./product-specs/mild.svg": "d06e",
	"./product-specs/vegan.svg": "4788",
	"./product-specs/vegetarian.svg": "5711",
	"./product.svg": "8418",
	"./products-icon.svg": "cfad",
	"./prohibit.svg": "3436",
	"./pt.svg": "bc09",
	"./pw.svg": "2d6a",
	"./py.svg": "e49a",
	"./qa.svg": "bb87",
	"./qr.svg": "01ea",
	"./question.svg": "24dc",
	"./reports.svg": "771f",
	"./reservas.svg": "be2c",
	"./reuse.svg": "6185",
	"./ro.svg": "629e",
	"./rotar.svg": "f543",
	"./rs.svg": "e626",
	"./ru.svg": "adf9",
	"./rw.svg": "d881",
	"./sa.svg": "40c7",
	"./sb.svg": "b6aa",
	"./sc.svg": "41a7",
	"./screen.svg": "8a0aa",
	"./sd.svg": "b697",
	"./se.svg": "3396",
	"./search.svg": "3cc1",
	"./select-all.svg": "764c",
	"./settings.svg": "741b",
	"./sg.svg": "4c7c",
	"./shop.svg": "80e9",
	"./si.svg": "c316",
	"./sk.svg": "60e5",
	"./sl.svg": "9bef",
	"./sm.svg": "767d",
	"./small-arrow-right.svg": "1c39c",
	"./sn.svg": "0c16",
	"./so.svg": "bf38",
	"./square-menu.svg": "d6e4",
	"./sr.svg": "81d0",
	"./ss.svg": "b851",
	"./st.svg": "8868",
	"./star.svg": "a02b",
	"./store.svg": "d3ac",
	"./sunday-logo.svg": "2f50",
	"./super-tip.svg": "1754",
	"./support.svg": "d698",
	"./sv.svg": "9f59",
	"./sy.svg": "3cff",
	"./sync.svg": "523f",
	"./sz.svg": "4f3e",
	"./tabs.svg": "f296",
	"./take-away-small.svg": "581a",
	"./take-away.svg": "1c03",
	"./td.svg": "e48d",
	"./tg.svg": "5c5d",
	"./th.svg": "0f389",
	"./ticket.svg": "8a8c",
	"./till.svg": "d53b8",
	"./time.svg": "2ede",
	"./tip.svg": "6adc",
	"./tj.svg": "5ac7",
	"./tl.svg": "60d0",
	"./tm.svg": "e5b4",
	"./tn.svg": "90439",
	"./to.svg": "23f1",
	"./tr.svg": "3d84",
	"./trash.svg": "99609",
	"./tt.svg": "bd50",
	"./turn-off.svg": "ca92",
	"./tv.svg": "d6a0",
	"./tz.svg": "4c11",
	"./ua.svg": "d747",
	"./ug.svg": "c4d4",
	"./union.svg": "863f",
	"./upload.svg": "d38f",
	"./us.svg": "ece0",
	"./user.svg": "8cd3",
	"./uy.svg": "1ea4",
	"./uz.svg": "e1e8",
	"./validate.svg": "06ad",
	"./ve.svg": "ca3f",
	"./vn.svg": "4ec7",
	"./warning-dark.svg": "b806",
	"./warning.svg": "0c14",
	"./ws.svg": "314c",
	"./ye.svg": "de54",
	"./za.svg": "e31c",
	"./zm.svg": "adbe",
	"./zoom.svg": "a7e6",
	"./zw.svg": "be8b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c06";